import React from 'react';
import { BrowserRouter, Navigate, Route, Routes } from 'react-router-dom';
import { Toaster } from 'react-hot-toast';
import { AuthProvider, useAuth } from './contexts/AuthContext';
import Layout from './components/Layout';
import Login from './pages/Login';
import Dashboard from './pages/Dashboard';
import JobManagement from './pages/JobManagement';
import JobDetails from './pages/JobDetails';
import CreateJob from './pages/CreateJob';
import PendingRegistrations from './pages/PendingRegistrations';
import Accounts from './pages/Accounts';
import AccountForm from './pages/AccountForm';
import Locations from './pages/Locations';
import LocationForm from './pages/LocationForm';
import Vendors from './pages/Vendors';
import VendorForm from './pages/VendorForm';
import Users from './pages/Users';
import InviteAdmin from './pages/InviteAdmin';
import AdminSignup from './pages/AdminSignup';
import ChangePassword from './pages/ChangePassword';
import PendingVendorApplications from './pages/PendingVendorApplications';
import VendorApplicationDetail from './pages/VendorApplicationDetail';

const PrivateRoutes = () => {
  const { isAuthenticated, isLoading, mustChangePassword } = useAuth();
  if (isLoading) return <p className="p-8">Loading…</p>;
  if (!isAuthenticated) return <Navigate to="/login" replace />;
  if (mustChangePassword) return <Navigate to="/change-password" replace />;
  return (
    <Routes>
      <Route element={<Layout />}>
        <Route path="/" element={<Navigate to="/dashboard" replace />} />
        <Route path="/dashboard" element={<Dashboard />} />
        <Route path="/jobs" element={<JobManagement />} />
        <Route path="/jobs/new" element={<CreateJob />} />
        <Route path="/jobs/:id" element={<JobDetails />} />
        <Route path="/registrations" element={<PendingRegistrations />} />
        <Route path="/accounts" element={<Accounts />} />
        <Route path="/accounts/new" element={<AccountForm />} />
        <Route path="/accounts/:id/edit" element={<AccountForm />} />
        <Route path="/locations" element={<Locations />} />
        <Route path="/locations/new" element={<LocationForm />} />
        <Route path="/locations/:id/edit" element={<LocationForm />} />
        <Route path="/vendor-applications" element={<PendingVendorApplications />} />
        <Route path="/vendor-applications/:id" element={<VendorApplicationDetail />} />
        <Route path="/vendors" element={<Vendors />} />
        <Route path="/vendors/new" element={<VendorForm />} />
        <Route path="/vendors/:id/edit" element={<VendorForm />} />
        <Route path="/users" element={<Users />} />
        <Route path="/users/new" element={<InviteAdmin />} />
      </Route>
    </Routes>
  );
};

const PasswordChangeRoute = () => {
  const { isAuthenticated, isLoading, mustChangePassword } = useAuth();
  if (isLoading) return <p className="p-8">Loading…</p>;
  if (!isAuthenticated) return <Navigate to="/login" replace />;
  if (!mustChangePassword) return <Navigate to="/dashboard" replace />;
  return <ChangePassword />;
};

function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <Routes>
          <Route path="/login" element={<Login />} />
          <Route path="/signup" element={<AdminSignup />} />
          <Route path="/change-password" element={<PasswordChangeRoute />} />
          <Route path="/*" element={<PrivateRoutes />} />
        </Routes>
        <Toaster position="top-right" />
      </BrowserRouter>
    </AuthProvider>
  );
}

export default App;
